export const ADMIN_ARTICLES_VIEW_ROUTE_NAME = Symbol('admin.articles.view');
export const AFFILIATE_ARTICLES_VIEW_ROUTE_NAME = Symbol('affiliate.articles.view');
